import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fdb-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent {

  constructor() { }

}
